// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * ServiceTokenAttributes type.
 * @typedef {object} ServiceTokenAttributes
 * @property {Date | null} createdAt - Attribute value.
 * @property {string} createdByUserId - Attribute value.
 * @property {Date | null} expiresAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {Date | null} lastUsedAt - Attribute value.
 * @property {string} name - Attribute value.
 * @property {Date | null} revokedAt - Attribute value.
 * @property {string | null} scopesJson - Attribute value.
 * @property {string} tokenPrefix - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by ServiceTokenCreateAttributes.
 * @typedef {object} ServiceTokenCreateAttributes
 * @property {ServiceTokenAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Attributes accepted by ServiceTokenUpdateAttributes.
 * @typedef {object} ServiceTokenUpdateAttributes
 * @property {ServiceTokenAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Frontend model for ServiceToken.
 * @augments {FrontendModelBase<ServiceTokenAttributes, ServiceTokenCreateAttributes, ServiceTokenUpdateAttributes, ServiceTokenAttributes["id"], string>}
 */
class ServiceToken extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "ServiceToken",
      attributes: [
        "createdAt",
        "createdByUserId",
        "expiresAt",
        "id",
        "lastUsedAt",
        "name",
        "revokedAt",
        "scopesJson",
        "tokenPrefix",
        "updatedAt",
      ],
      collectionCommands: [
        "generate",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      createdByUser: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      createdByUser: "User",
    }
  }

  /** @returns {ServiceTokenAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {ServiceTokenAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {ServiceTokenAttributes["createdByUserId"]} - Attribute value. */
  createdByUserId() { return /** @type {ServiceTokenAttributes["createdByUserId"]} */ (this.readAttribute("createdByUserId")) }

  /**
   * @param {ServiceTokenAttributes["createdByUserId"] | null} newValue - New attribute value.
   * @returns {ServiceTokenAttributes["createdByUserId"] | null} - Assigned value.
   */
  setCreatedByUserId(newValue) { return /** @type {ServiceTokenAttributes["createdByUserId"] | null} */ (this.setAttribute("createdByUserId", newValue)) }

  /** @returns {ServiceTokenAttributes["expiresAt"]} - Attribute value. */
  expiresAt() { return /** @type {ServiceTokenAttributes["expiresAt"]} */ (this.readAttribute("expiresAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setExpiresAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("expiresAt", newValue)) }

  /** @returns {ServiceTokenAttributes["id"]} - Attribute value. */
  id() { return /** @type {ServiceTokenAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {ServiceTokenAttributes["id"] | null} newValue - New attribute value.
   * @returns {ServiceTokenAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {ServiceTokenAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {ServiceTokenAttributes["lastUsedAt"]} - Attribute value. */
  lastUsedAt() { return /** @type {ServiceTokenAttributes["lastUsedAt"]} */ (this.readAttribute("lastUsedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setLastUsedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("lastUsedAt", newValue)) }

  /** @returns {ServiceTokenAttributes["name"]} - Attribute value. */
  name() { return /** @type {ServiceTokenAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {ServiceTokenAttributes["name"] | null} newValue - New attribute value.
   * @returns {ServiceTokenAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {ServiceTokenAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {ServiceTokenAttributes["revokedAt"]} - Attribute value. */
  revokedAt() { return /** @type {ServiceTokenAttributes["revokedAt"]} */ (this.readAttribute("revokedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setRevokedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("revokedAt", newValue)) }

  /** @returns {ServiceTokenAttributes["scopesJson"]} - Attribute value. */
  scopesJson() { return /** @type {ServiceTokenAttributes["scopesJson"]} */ (this.readAttribute("scopesJson")) }

  /**
   * @param {ServiceTokenAttributes["scopesJson"] | null} newValue - New attribute value.
   * @returns {ServiceTokenAttributes["scopesJson"] | null} - Assigned value.
   */
  setScopesJson(newValue) { return /** @type {ServiceTokenAttributes["scopesJson"] | null} */ (this.setAttribute("scopesJson", newValue)) }

  /** @returns {ServiceTokenAttributes["tokenPrefix"]} - Attribute value. */
  tokenPrefix() { return /** @type {ServiceTokenAttributes["tokenPrefix"]} */ (this.readAttribute("tokenPrefix")) }

  /**
   * @param {ServiceTokenAttributes["tokenPrefix"] | null} newValue - New attribute value.
   * @returns {ServiceTokenAttributes["tokenPrefix"] | null} - Assigned value.
   */
  setTokenPrefix(newValue) { return /** @type {ServiceTokenAttributes["tokenPrefix"] | null} */ (this.setAttribute("tokenPrefix", newValue)) }

  /** @returns {ServiceTokenAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {ServiceTokenAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Runs generate.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{serviceToken: {createdAt: Date | null, createdByUserId: string, expiresAt: Date | null, id: string, lastUsedAt: Date | null, name: string, revokedAt: Date | null, scopes: string[], tokenPrefix: string}, token: string}>} - Command response.
   */
  static async generate(...commandArguments) {
    return /** @type {{serviceToken: {createdAt: Date | null, createdByUserId: string, expiresAt: Date | null, id: string, lastUsedAt: Date | null, name: string, revokedAt: Date | null, scopes: string[], tokenPrefix: string}, token: string}} */ (await this.executeCustomCommand({
      commandName: "generate",
      commandType: "generate",
      payload: ServiceToken.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns createdByUser relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ServiceToken, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  createdByUserRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<ServiceToken, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("createdByUser")) }

  /**
   * Returns createdByUser.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  createdByUser() { return this.createdByUserRelationship().loaded() }

  /**
   * Builds createdByUser.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildCreatedByUser(attributes = {}) { return this.createdByUserRelationship().build(attributes) }

  /**
   * Loads createdByUser.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadCreatedByUser() { return await this.createdByUserRelationship().load() }

  /**
   * Returns or loads createdByUser.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async createdByUserOrLoad() { return await this.createdByUserRelationship().orLoad() }

  /**
   * Sets createdByUser.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setCreatedByUser(model) { this.createdByUserRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(ServiceToken)

export {ServiceToken}

export default ServiceToken
